var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 8,
    viewBox: "0 0 34 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7804 6.01964C17.7966 6.01964 18.6204 5.19676 18.6204 4.18169C18.6204 3.16662 17.7966 2.34375 16.7804 2.34375C15.7642 2.34375 14.9404 3.16662 14.9404 4.18169C14.9404 5.19676 15.7642 6.01964 16.7804 6.01964Z",
    stroke: "black",
    strokeWidth: 3.20152,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6605 6.01964C30.6767 6.01964 31.5005 5.19676 31.5005 4.18169C31.5005 3.16662 30.6767 2.34375 29.6605 2.34375C28.6443 2.34375 27.8205 3.16662 27.8205 4.18169C27.8205 5.19676 28.6443 6.01964 29.6605 6.01964Z",
    stroke: "black",
    strokeWidth: 3.20152,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.90032 6.01964C4.91653 6.01964 5.74033 5.19676 5.74033 4.18169C5.74033 3.16662 4.91653 2.34375 3.90032 2.34375C2.88411 2.34375 2.0603 3.16662 2.0603 4.18169C2.0603 5.19676 2.88411 6.01964 3.90032 6.01964Z",
    stroke: "black",
    strokeWidth: 3.20152,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.97321fd9083ef95d16368cb20de909e4.svg";
export { ForwardRef as ReactComponent };